import { useMemo } from 'react';

import { FHChip, FHSimpleTable } from '../../../../../../components/base';
import {
  QUESTIONNAIRE_CHIP_FONT_SIZE,
  QUESTIONNAIRE_CHIP_WIDTH,
  QUESTIONNAIRE_STATUS_COLORS,
  QUESTIONNAIRE_TABLE_OPTIONS,
  QUESTIONNAIRE_TYPE_COLORS,
} from '../constants';
import { questionnaireDateSortCompare } from '../utils';
import QuestionnaireIdLink from './QuestionnaireIdLink';

import type { ProviderQuestionnaireTableRow, QuestionnaireStatusTableProps } from '../types';

function QuestionnaireStatusTable({ rows }: QuestionnaireStatusTableProps) {
  const columns = useMemo(
    () => [
      {
        name: 'type',
        label: 'Type',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value: ProviderQuestionnaireTableRow['type']) => (
            <FHChip
              content={value}
              bgColor={QUESTIONNAIRE_TYPE_COLORS[value]}
              fontSize={QUESTIONNAIRE_CHIP_FONT_SIZE}
              sx={{ width: QUESTIONNAIRE_CHIP_WIDTH, textAlign: 'center' }}
            />
          ),
        },
      },
      {
        name: 'client',
        label: 'Client',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value: ProviderQuestionnaireTableRow['status']) => (
            <FHChip
              content={value}
              bgColor={QUESTIONNAIRE_STATUS_COLORS[value]}
              fontSize={QUESTIONNAIRE_CHIP_FONT_SIZE}
              sx={{ width: QUESTIONNAIRE_CHIP_WIDTH, textAlign: 'center' }}
            />
          ),
        },
      },
      {
        name: 'date_sent',
        label: 'Date Sent',
        options: {
          filter: false,
          sort: true,
          sortCompare: questionnaireDateSortCompare,
        },
      },
      {
        name: 'date_concluded',
        label: 'Date Concluded',
        options: {
          filter: false,
          sort: true,
          sortCompare: questionnaireDateSortCompare,
        },
      },
      {
        name: 'questionnaire_id',
        label: 'Questionnaire Id',
        options: {
          filter: false,
          sort: true,
          customBodyRenderLite: (dataIndex: number) => {
            const row = rows[dataIndex];
            if (!row) return null;

            return <QuestionnaireIdLink path={row.path} label={row.questionnaire_id} />;
          },
        },
      },
    ],
    [rows],
  );

  return (
    <FHSimpleTable
      data={rows}
      columnDefinitions={columns}
      columnOptions={QUESTIONNAIRE_TABLE_OPTIONS}
    />
  );
}

export default QuestionnaireStatusTable;
